import {TableText} from '../components'

export const ExtLinkCell = ({getValue, column}) => {
	// truncate={false} is required to prevent the text from becoming an inline block, influencing the vertical position within the cell
	const {t} = column.columnDef
	const href = getValue()

	// Prevent the row count being pushed to the next line in collapsible, grouped cells.
	const style = {display: 'inline-block'}

	// clicks directly on the <a> are handled automatically, clicks within the cell BUT outside the <a> are handeld handled by a
	// querySelector in the cell, see helper function below.
	return (
		<a target="_blank" href={href} style={style} onClick={e => e.stopPropagation()} rel="noreferrer">
			<TableText t={t || 'common.link'} hyperlink truncate={false} />
		</a>
	)
}
